import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-brand text-brand-inverse',
        secondary: 'border-transparent bg-brand-tint/60 text-brand-ink',
        destructive: 'border-transparent bg-red-100 text-status-error border-status-error/20',
        outline: 'text-brand-ink border-brand-border bg-surface',
        todo: 'border-transparent bg-slate-100 text-brand-muted',
        active: 'border-transparent bg-emerald-50 text-status-success border-status-success/20',
        in_progress: 'border-transparent bg-brand-tint/60 text-brand border-brand/20',
        in_review: 'border-transparent bg-amber-50 text-status-warning border-status-warning/20',
        on_hold: 'border-transparent bg-yellow-50 text-status-warning border-status-warning/20',
        completed: 'border-transparent bg-teal-50 text-brand border-brand/20',
        cancelled: 'border-transparent bg-slate-100 text-brand-muted border-brand-border',
        at_risk: 'border-transparent bg-rose-50 text-status-error border-status-error/20',
        blocked: 'border-transparent bg-rose-50 text-status-error border-status-error/20',
        done: 'border-transparent bg-[#D2EBE4] text-status-success border-status-success/30 font-bold',
        manual: 'border-transparent bg-purple-50 text-purple-800 border-purple-200',
        urgent: 'border-transparent bg-red-50 text-status-error border-status-error/20',
        high: 'border-transparent bg-orange-50 text-orange-700 border-orange-200',
        medium: 'border-transparent bg-teal-50 text-brand border-brand/20',
        low: 'border-transparent bg-slate-100 text-brand-muted border-brand-border',
        success: 'border-transparent bg-[#D2EBE4] text-status-success border-status-success/20 font-semibold',
        warning: 'border-transparent bg-amber-50 text-status-warning border-status-warning/20 font-semibold',
        error: 'border-transparent bg-red-50 text-status-error border-status-error/20 font-semibold',
        mint: 'border-transparent bg-brand-tint text-brand-ink font-semibold',
        lime: 'border-transparent bg-brand-lime text-brand-ink font-bold',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
